import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-margin-trading',
  templateUrl: './margin-trading.component.html',
  styleUrls: ['./margin-trading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarginTradingComponent implements OnInit {
  currentUser;
  marginTradeDetails;
  availableBalance;
  balanceInProgress = false;

  constructor(
    private accountSerice: AccountService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService
  ) { }

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  async ngOnInit() {
    try {
      this.balanceInProgress = true;
      this.currentUser = await this.accountSerice.currentUserAsync();
      await this.loadBalances();
    } catch (e) {
      this.balanceInProgress = false;
      this.cdRef.detectChanges();
    }
  }

  // The account list has names only. Each holding is marketValueTotal from today's portfolio.
  async loadBalances() {
    const accounts = this.currentUser?.marginTradeDetails || [];
    const today = moment().format('YYYY-MM-DD');
    const results = await Promise.allSettled(
      accounts.map((margin) => this.accountSerice.getMarginTradePortfolio(today, margin.customerCode))
    );
    const cached = [];
    results.forEach((result, i) => {
      const total = result.status === 'fulfilled' ? this.toAmount(result.value?.marketValueTotal) : 0;
      accounts[i].balance = total;
      cached.push({ code: String(accounts[i].customerCode), total });
    });
    this.marginTradeDetails = cached;
    localStorage.setItem('marginTradeDetails', JSON.stringify(cached));
    localStorage.setItem('marginTradeTotalDate', today);
    this.balanceInProgress = false;
    this.cdRef.detectChanges();
  }

  private toAmount(value: any): number {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
      const parsed = Number(value.replace(/,/g, '').trim());
      return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
  }
}
